export const lang = {
  语言: "English",
  登录: "登录",
  微信登录: "微信登录",
  账户登录: "账户登录",
  请使用微信扫描二维码登录: "请使用微信扫描二维码登录",
  公司版权所有北京路晨伟业仪器设备有限公司: "公司版权所有：北京路晨伟业仪器设备有限公司",
  京ICP备18062262号1: "京ICP备18062262号-1",
  设备数据: "设备数据",
  首页: "首页",
  手动单通道: "手动单通道",
  自动单通道: "自动单通道",
  手动双通道: "手动双通道",
  自动双通道: "自动双通道",
  单通道带剪切力: "单通道带剪切力",
  静力触探: "静力触探",
  修改密码: "修改密码",
  退出: "退出",
  旧密码: "旧密码",
  新密码: "新密码",
  确认新密码: "确认新密码",
  保存: "保存",
  取消: "取消",
  密码至少为6位: "密码至少为6位",
  密码错误: "密码错误",
  微信用户: "微信用户",
  确定要退出吗: "确定要退出吗？",
  新增绑定设备: "新增绑定设备",
  设备序列号: "设备序列号",
  经销商电话: "经销商电话",
  备注: "备注",
  绑定: "绑定",
  重置: "重置",
  序列号: "序列号",
  已绑定设备: "已绑定设备",
  设备类型: "设备类型",
  绑定时间: "绑定时间",
  操作: "操作",
  解绑: "解绑",
  请输入序列号: "请输入序列号",
  请输入经销商电话: "请输入经销商电话",
  请输入备注: "请输入备注",
  确定要解绑吗: "确定要解绑吗？",
  由斯姆捷科技有限公司提供技术支持: "由斯姆捷科技有限公司提供技术支持",
  日期: "日期",
  孔号: "孔号",
  试验时间: "试验时间",
  截面积: "截面积",
  表面积: "表面积",
  位移点长度: "位移点长度",
  起始深度: "起始深度",
  打印: "打印",
  导出: "导出",
  删除: "删除",
  图形: "图形",
  详细信息: "详细信息",
  深度: "深度",
  阻力: "阻力",
  锥尖阻力: "锥尖阻力",
  确定要删除吗: "确定要删除吗?",
  深度压强: "深度/压强",
  压强: "压强",
  全屏: "全屏",
  打印图表: "打印图表",
  导出JPEG: "导出 JPEG",
  导出PDF: "导出 PDF",
  导出PNG: "导出 PNG",
  导出SVG: "导出 SVG",
  试验编号: "试验编号",
  侧壁阻力: "侧壁阻力",
  深度锥尖阻力: "深度/锥尖阻力",
  深度侧壁阻力: "深度/侧壁阻力",
  土类型: "土类型",
  工程编号: "工程编号",
  试验深度: "试验深度",
  运行系数: "运行系数",
  孔口高度: "孔口高度",
  地下水位: "地下水位",
  角度: "角度",
  抗剪强度: "抗剪强度",
  存在空数据: "存在空数据",
  请选择一条原状土和一条重塑土记录: "请选择一条原状土和一条重塑土记录",
  角度抗剪强度: "角度/抗剪强度",
  修改成功: "修改成功",
  密码不一致: "密码不一致",
  修改失败: "修改失败",
  请求失败: "请求失败!",
  请输入账号: "请输入账号",
  请输入密码: "请输入密码",
  重塑土: "重塑土",
  原状土: "原状土",
  测缝仪: "测缝仪",
  测缝仪数据查询: "测缝仪数据查询",
  构件: "构件",
  最大缝宽: "最大缝宽",
  最小缝宽: "最小缝宽",
  平均缝宽: "平均缝宽",
  加载中: "加载中",
  测点: "测点",
  缝宽: "缝宽",
  工程管理: "工程管理",
  增加: "增加",
  编辑: "编辑",
  测位管理: "测位管理",
  测点管理: "测点管理",
  无数据: "无数据",
  工程信息: "工程信息",
  工程名称: "工程名称",
  开始时间: "开始时间",
  结束时间: "结束时间",
  测位信息: "测位信息",
  测位名称: "测位名称",
  测点信息: "测点信息",
  测点名称: "测点名称",
  请输入测点名称: "请输入测点名称",
  请选择设备: "请选择设备",
  设备通道: "设备通道",
  请选择通道: "请选择通道",
  请输入工程名称: "请输入工程名称",
  请输入开始日期: "请输入开始日期",
  请输入结束日期: "请输入结束日期",
  请输入测位名称: "请输入测位名称",
  测点设备: "测点设备",
  测点通道: "测点通道",
  表层: "表层",
  中: "中",
  中上: "中上",
  中下: "中下",
  底层: "底层",
  环境: "环境",
  请选择项目: "请选择项目",
  删除成功: "删除成功",
  保存成功: "保存成功",
  请选择测位: "请选择测位",
  开始日期: "开始日期",
  结束日期: "结束日期",
  公司名称: "公司名称",
  修改公司名称: "修改公司名称",
  请选择测点: "请选择测点",
  选择日期: "选择日期",
  我的工程: "我的工程",
  测位列表: "测位列表",
  请选择工程: "请选择工程",
  请至工程管理增加测位: "请至'工程管理'增加测位",
  导出峰值数据: "导出数据",
  原始数据导出见我的设备: "原始数据导出见'我的设备'",
  该测位下无测点: "该测位下无测点",
  通道: "通道",
  最新温度: "最新温度",
  返回时间: "采集时间",
  峰值: "峰值",
  峰值时间: "峰值时间",
  谷值: "谷值",
  谷值时间: "谷值时间",
  平均值: "平均值",
  测点无数据: "测点无数据",
  项目起止: "项目起止",
  请选择日期: "请选择日期",
  温度: "温度",
  时间: "时间",
  温度曲线图: "温度曲线图",
  温差报警: "温差报警",
  上下限报警: "上下限报警",
  每天降温报警: "每天降温报警",
  每四小时降温报警: "每四小时降温报警",
  温差名称: "温差名称",
  设置差值: "设置差值",
  通道1: "通道1",
  通道1时间: "通道1时间",
  通道1温度: "通道1温度",
  通道2: "通道2",
  通道2时间: "通道2时间",
  通道2温度: "通道2温度",
  上下限名称: "上下限名称",
  通道时间: "通道时间",
  通道温度: "通道温度",
  上限值: "上限值",
  下限值: "下限值",
  时间间隔: "时间间隔",
  平均温度: "平均温度",
  降温速率报警与最大温度: "降温速率报警与最大温度",
  选择设备: "选择设备",
  每天降温: "每天降温",
  每四小时降温: "每四小时降温",
  T1最大温度: "T1最大温度",
  T2最大温度: "T2最大温度",
  T3最大温度: "T3最大温度",
  T4最大温度: "T4最大温度",
  T5最大温度: "T5最大温度",
  T6最大温度: "T6最大温度",
  T7最大温度: "T7最大温度",
  T8最大温度: "T8最大温度",
  水泵绑定: "水泵绑定",
  报警间隔: "报警间隔",
  差值: "差值",
  分钟: "分钟",
  名称: "名称",
  开关: "开关",
  请输入开关imei: "请输入开关imei",
  继电器1: "继电器1",
  继电器2: "继电器2",
  继电器3: "继电器3",
  继电器4: "继电器4",
  开关明细: "开关明细",
  关闭: "关闭",
  请输入温差名称: "请输入温差名称",
  请选择工程名称: "请选择工程名称",
  请输入报警间隔: "请输入报警间隔",
  报警间隔必须为数字值: "报警间隔必须为数字值",
  请输入差值: "请输入差值",
  请输入上下限名称: "请输入上下限名称",
  创建时间: "创建时间",
  请输入名称: "请输入名称",
  长度15个字符: "长度15个字符",
  请选择继电器: "请选择继电器",
  开关imei: "开关imei",
  继电器: "继电器",
  明细: "明细",
  请选择一条记录: "请选择一条记录",
  电池电量: "电池电量",
  无记录: "无记录",
  刷新: "刷新",
  天: "天",
  未配置工程信息: "未配置工程信息",
  工程: "工程",
  测位: "测位",
  数字格式不正确: "数字格式不正确",
  时间格式不正确: "时间格式不正确",
  至: "至",
  小时: "小时",
  无线测温仪: "无线测温仪",
  报警管理: "报警管理",
  我的设备: "我的设备",
  平均温度查询: "平均温度查询",
  报警记录查询: "报警记录查询",
  公司名称不能为空: "公司名称不能为空",
  二维码: "二维码",
  工程地址: "工程地址",
  请输入工程地址: "请输入工程地址",
  测点绑定: "测点绑定",
  传感器序列号: "传感器序列号",
  不能为空: "不能为空",
  确定要覆盖吗: "确定要覆盖吗?",
  已绑定: "已绑定",
  请选择: "请选择",
  多次: "多次",
  是: "是",
  否: "否",
  其他人绑定中: "其他人绑定中",
  降温速率报警: "降温速率报警",
  前一天: "前一天",
  后一天: "后一天",
  报警记录: "报警记录",
  编辑名称: "编辑名称",
  查看数据: "查看数据",
  解除绑定: "解除绑定",
  原始数据: "原始数据",
  计算结果: "计算结果",
  标定点: "标定点",
  电势: "电势",
  计算: "计算",
  空: "空",
  请输入温度: "请输入温度",
  电阻率: "电阻率",
  电阻率数据查询: "电阻率数据查询",

  WIFI打印: "WIFI打印",
  USB打印: "USB打印",
  A4打印: "A4打印",
  检测道路: "检测道路",
  检测路段: "检测路段",
  检测班组: "检测班组",
  检测员: "检测员",
  坐标: "坐标",
  道路号: "道路号",
  路幅号: "路幅号",
  里程号: "里程号",
  起始桩号: "起始桩号",
  极限差值: "极限差值",
  百米清零: "百米清零",
  上传: "上传",
  正向累计值: "正向累计值",
  负向累计值: "负向累计值",
  正超差值: "正超差值",
  负超差值: "负超差值",
  平均速度: "平均速度",
  累计面积: "累计面积",
  平整度: "平整度",
  测试点: "测试点",
  位移: "位移",
  无地址信息: "无地址信息",
  打印机序列号: "打印机序列号",
  请输入打印机序列号: "请输入打印机序列号",
  确定要上传吗: "确定要上传吗?",
  数据上传中: "数据上传中",
  上传成功: "上传成功",
  型8平整度数据查询: "8型平整度数据查询",
  型7平整度数据查询: "7型平整度数据查询",
  次: "次",
  请选中行: "请选中行",
  超差值: "超差值",
  打印选项: "打印选项",
  正在发送打印命令: "正在发送打印命令",
  发送打印命令成功: "发送打印命令成功",
  请配置公司名称: "请配置公司名称",
  测试长度: "测试长度",
  试验方法: "试验方法",
  检测对象: "检测对象",
  试验类型: "试验类型",
  电位法: "电位法",
  电位滴定法: "电位滴定法",
  水泥: "水泥",
  外加剂: "外加剂",
  空白: "空白",
  硝酸银: "硝酸银",
  氯化物: "氯化物",
  拌合物: "拌合物",
  水灰比: "水灰比",
  质量体积: "质量体积",
  上一页: "上一页",
  下一页: "下一页",
  运行时长: "运行时长",
  空白试验结果: "空白试验结果",
  曲线1: "曲线1",
  曲线2: "曲线2",
  体积: "体积",
  硝酸银试验结果: "硝酸银试验结果",
  硝酸银试验结果1: "硝酸银试验结果1",
  硝酸银试验结果2: "硝酸银试验结果2",
  标准液体积: "标准液体积",
  标准液浓度: "标准液浓度",
  硝酸银浓度: "硝酸银浓度",
  空白试验结果1: "空白试验结果1",
  空白试验结果2: "空白试验结果2",
  氯化物试验结果1: "氯化物试验结果1",
  氯化物试验结果2: "氯化物试验结果2",
  氯化物试验结果: "氯化物试验结果",
  氯化物质量: "氯化物质量",
  质量百分比: "质量百分比",
  氯离子: "氯离子",
  氯离子数据查询: "氯离子数据查询",
  氯离子计算工具: "氯离子计算工具",
  查看: "查看",
  我的测点: "我的测点",
  请至少选择一条数据: "请至少选择一条数据！",
  软化点: "软化点",
  软化点数据查询: "软化点数据查询",
  小球: "小球",
  导入数据: "导入数据",
  编辑记录: "编辑记录",
  每分钟数据: "每分钟数据",
  必须输入数字以逗号隔开: "必须输入数字以逗号隔开",
  请输入试验编号: "请输入试验编号",
  请输入时间: "请输入时间",

  //侯棒棒
  传感器: "传感器",
  传感器1: "传感器1",
  传感器2: "传感器2",
  传感器温度: "传感器温度",
  传感器1温度: "传感器1温度",
  传感器2温度: "传感器2温度",
  传感器时间: "传感器时间",
  传感器1时间: "传感器1时间",
  传感器2时间: "传感器2时间",
  全部标为已读: "全部标为已读",
  上限值必须为数字值: "上限值必须为数字值",
  下限值必须为数字值: "下限值必须为数字值",
  请输入上限值: "请输入上限值",
  请输入下限值: "请输入下限值",
  背光时长: "背光时长",
  采样间隔: "采样间隔",
  是否开机升级: "是否开机升级",
  请输入背光时长: "请输入背光时长",
  请输入采样间隔: "请输入采样间隔",
  保存失败: "保存失败",
  必须为数字值: "必须为数字值",
  密码为四位数字: "密码为四位数字",
  必须为整数: "必须为整数",
  对接公司名称: "对接公司名称",
  t1序列号: "t1序列号",
  t2序列号: "t2序列号",
  t3序列号: "t3序列号",
  t4序列号: "t4序列号",
  t5序列号: "t5序列号",
  t6序列号: "t6序列号",
  t7序列号: "t7序列号",
  t8序列号: "t8序列号",
};
